import React from 'react';
import { Col, Row } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import {FormattedMessage} from 'react-intl';

const About = (props) => {
  	const { classes } = props;

  	/**Component generating two tabs*/
  	return (
    <div className={classes.popup_background}>
        <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", fontWeight:"bold", fontSize: "1.2em"}}>
            <div className="submit-form">
                <Row>
    		      	<Col style={{textAlign: "center"}}>
    		      		Tucky Center Version {process.env.REACT_APP_VERSION} <br/><br/>
                        © e-TakesCare - All Rights Reserved <br/><br/>
                        <a href= "https://www.e-takescare.com/legal#cgu_app" target="_blank"><FormattedMessage id="about.termsOfUse" defaultMessage="Terms ofUse" /></a>
    		      	</Col>
    		    </Row>
    		    <br/>
    		    <center>
    		        <button onClick={props.cancelPopup} className="btn btn-danger">
                        <FormattedMessage id="button.close" defaultMessage="Close" />                                           
                    </button>
                </center>
            </div>
        </div>
    </div>
    );
};
export default withStyles(Constants.styles)(About);